<div class="agency">

<!--section 404 start-->
<div class="bg-purple">
    <div class="section-404">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 col-12">
                    <div class="">
                        <p class="text-404 text-white text-center">Looking for our online order portal? <br />

                        On our B2B portal site you can:</p>
                        <br />
                        <ul class="text-404 text-white text-center">
                            <li>Place new orders</li>
                            <li>Check stock</li>
                            <li>View old orders</li>
                            <li>Select roll balances and clearance stock</li>
                        </ul>
                        <p class="text-404 text-white text-center">
                         This is accessed as a seperate website, please find the link below: <br /><br />
                        
                        <a href="https://portal.solentwholesale.com/" class="btn btn-default btn-large primary-btn transparent m-t-20">Portal</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--section 404 end-->
</div>
